import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

type TikTokVideoCtaProps = {
    title: string;
    description: string;
    url: string;
    compact?: boolean;
};

const TikTokVideoCta: React.FC<TikTokVideoCtaProps> = ({
    title,
    description,
    url,
    compact = false,
}) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: compact ? 'row' : 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: { xs: 1.5, sm: 2 },
            p: compact ? 2 : 2.5,
            borderRadius: 2,
            border: '1px solid rgba(25, 118, 210, 0.22)',
            bgcolor: 'rgba(25, 118, 210, 0.05)',
        }}
    >
        <PlayCircleOutlineIcon
            sx={{
                fontSize: compact ? 32 : 40,
                color: 'primary.main',
                flexShrink: 0,
                alignSelf: { xs: 'center', sm: 'flex-start' },
                mt: { sm: compact ? 0 : 0.25 },
            }}
        />
        <Box sx={{ flex: 1, minWidth: 0, textAlign: { xs: 'center', sm: 'left' } }}>
            <Typography
                variant={compact ? 'subtitle2' : 'subtitle1'}
                sx={{ fontWeight: 700, lineHeight: 1.35, mb: 0.35 }}
            >
                {title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
                {description}
            </Typography>
        </Box>
        <Button
            component="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            color="primary"
            size={compact ? 'small' : 'medium'}
            endIcon={<OpenInNewIcon sx={{ fontSize: '1rem !important' }} />}
            sx={{
                flexShrink: 0,
                alignSelf: { xs: 'stretch', sm: 'center' },
                fontWeight: 600,
                textTransform: 'none',
                whiteSpace: 'nowrap',
            }}
        >
            Watch on TikTok
        </Button>
    </Box>
);

export default TikTokVideoCta;
